// material-ui
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import Loading from 'contexts/loading-spinner/loading-spinner';

// loader style
const LoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2001,
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2)
  }
}));

// ==============================|| Loader ||============================== //

const Loader = ({ text = 'Cargando...' }) => (
  <LoaderWrapper>
    {/* <LinearProgress color="primary" /> */}
    <Loading text={text} />
  </LoaderWrapper>
);

export default Loader;
